import EstadoDeudaList from './EstadoDeudaList'
export {EstadoDeudaList}
export default EstadoDeudaList
